import { Component, Output, EventEmitter } from '@angular/core'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'customer-portal-ios-add-homescreen-banner',
  standalone: true,
  imports: [MatIcon, HubChildTranslateModule],
  templateUrl: './ios-add-homescreen-banner.component.html'
})
export class IosAddHomescreenBannerComponent {
  @Output() public bannerDismiss = new EventEmitter<MouseEvent>()

  dismissBanner (event: MouseEvent): void {
    this.bannerDismiss.emit(event)
  }
}
